import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        justifyContent: 'center',
        padding: '24px',
        alignSelf: 'stretch',
        gap: '16px',
        flexDirection: 'column',
        alignItems: 'center'
    },
    paper: {
        maxWidth: theme.spacing(200),
        width: '100%',
        flex: 1
    },
    userDataGridWrapper: {
        border: 'none !important'
    },
    redDot: {
        fontSize: '0.8em !important',
        color: 'red',
        marginRight: '2px'
    },
    greenDot: {
        fontSize: '0.8em !important',
        color: 'green',
        marginRight: '2px'
    },
    blueDot: {
        color: 'blue'
    },
    hideRightSeparator: {
        '& > .MuiDataGrid-columnSeparator': {
            opacity: '0 !important'
        }
    }
}))
